import { RequireLogin } from "../../components/RequireLogin";
import { Layout } from "../../components/Layout";
import { useSectionsApi } from "../../hooks/api/useSectionsApi";
import { Loader } from "../../components/Loader";
import { Section } from "../../domains/Section";
import Link from "next/link";
import { useHttpError } from "../../components/ErrorView";
import SchoolIcon from "./icon-school.svg";

export const SectionsPage = () => {
  return (
    <RequireLogin>
      <Layout>
        <div className="px-4">
          <div className="l-index__title">
            <h1 className="is-size-4 has-text-weight-bold">校舎一覧</h1>
          </div>
          <div className="mt-7">
            <SectionList />
          </div>
        </div>
      </Layout>
    </RequireLogin>
  );
};

const SectionList = () => {
  const { data, isLoading, error } = useSectionsApi();
  useHttpError(error);

  if (isLoading) {
    return <Loader loading />;
  }

  if (data == null) {
    return null;
  }

  if (data.length == 0) {
    return <p>校舎がありません</p>;
  }

  return (
    <ul className="c-section-list">
      {data.map((section) => (
        <SectionListItem section={section} key={`section-${section.id}`} />
      ))}
    </ul>
  );
};

type SectionListItemProps = {
  section: Section;
};
const SectionListItem = ({ section }: SectionListItemProps) => {
  return (
    <li>
      <Link href={`/sections/${section.id}`}>
        <div className="c-section-list__link is-block px-4">
          <div className="c-section-list__item py-4 is-flex is-align-items-center is-justify-content-flex-start">
            <SchoolIcon />
            <div className="ml-3">{section.fullName}</div>
          </div>
        </div>
      </Link>
    </li>
  );
};
